<template>
  <div class="main">
    <div class="query-item">
      <div class="search-l">

      </div>
      <div class="search-r">
        <!--        <a-button class="ml30" @click="add" type="primary">+ 新建</a-button>-->
        <a-button class="ml30" type="primary" @click="router.push('/home/manage')"><i class="iconfont icon-fanhuiicon mr5"></i> 返回</a-button>
      </div>
    </div>

    <!-- 卡片式列表 -->
    <div class="card-list">
      <div class="zone-card" v-for="(record, index) in dataSource" :key="record.id">
        <!-- 卡片上半部分 -->
        <div class="card-top">
          <!-- 左侧图片 -->
          <div class="card-image">
            <img :src="record.image || 'https://via.placeholder.com/120x90?text=No+Image'" alt="区域图片" />
          </div>
          <!-- 右侧信息 -->
          <div class="card-info">
            <div class="zone-title">{{ record.name }}</div>
            <div class="zone-mileage">覆盖里程: {{ record.mileage || 0 }} 公里</div>
            <div class="zone-guide">{{ record.address || '' }}</div>
          </div>
        </div>
        <!-- 卡片下半部分描述 -->
        <div class="card-description">
          {{ formatContent(record.description) }}
        </div>
        <!-- 底部操作按钮 -->
        <div class="card-actions">
          <a class="ml10" @click="dashboardMockData(record)">大屏演示数据</a>
          <a class="ml10" @click="editZone(record)">修改</a>
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-container">
      <a-pagination
          v-model:current="pagination.current"
          v-model:page-size="pagination.pageSize"
          :page-size-options="pagination.pageSizeOptions"
          :total="pagination.total"
          show-size-changer
          show-quick-jumper
          :showTotal="pagination.showTotal"
          :show-size-change="pagination.showSizeChange"
          :on-change="pagination.onChange"
      />
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import { getList } from "@/api/test/testPath.js";
import useUserStore from '@/store/modules/user'

const router = useRouter();
const store = useUserStore();

let dataSource = ref([]);
let query = reactive({
  title: '',
  status: null
});

const pageChange = (page, pageSize) => {
  pagination.current = page;
  getData();
}

const pageSizeChange = (current, size) => {
  pagination.pageSize = size;
  getData();
}

const pagination = reactive({
  total: 0,
  size: "middle",
  defaultPageSize: 10,
  current: 1,
  pageSize: 10,
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"],
  showTotal: (total) => `共有 ${total} 条数据`,
  onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize), // 改变每页数量时更新显示
  onChange: pageChange, //点击页码事件
  showSizeChange: pageSizeChange,
});

const getData = () => {
  const data = {
    pageIndex: pagination.current,
    pageSize: pagination.pageSize,
    conditionMap: { ...query, deptId: store.deptId },
  };
  getList(data).then((res) => {
    if (res.code === 200) {
      dataSource.value = res.data || [];
      pagination.total = 2;
    }
  });
};

// 格式化内容，去除HTML标签并限制长度
const formatContent = (content) => {
  if (!content) return '';
  // 移除HTML标签
  const plainText = content.replace(/<[^>]*>/g, '');
  // 限制显示长度
  return plainText.length > 100 ? plainText.substring(0, 100) + '...' : plainText;
}

//打开大屏演示数据编辑
const dashboardMockData = (item) =>{
  router.push({
    path: '/zone/dashboardMockData',
    query: { id: item.id }
  });
}

// 打开编辑公告页面
const editZone = (item) => {
  router.push({
    path: '/zone/edit',
    query: { id: item.id }
  });
};

onMounted(async () => {
  getData();
});

</script>

<style lang="less" scoped>
.inp {
  width: 25vw;
}

.query-item {
  display: flex;
  justify-content: space-between;

  .search-l {
    display: flex;
  }

  .search-r {
    display: flex;
  }

  .status-select {
    width: 120px;
  }
}

.main {
  padding: 20px;
  min-height: calc(100vh - 70px);
  background-color: #ffffff;
}

.card-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 23px;
  // 响应式调整
  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

.zone-card {
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s;
  background: #fff;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #1890ff;
  }
}

// 卡片上半部分
.card-top {
  display: flex;
  margin-bottom: 12px;
}

.card-image {
  width: 180px; // 增大图片容器宽度
  height: 130px; // 增大图片容器高度
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 4px;
  background: #f5f5f5;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;

    // 鼠标悬停时轻微放大
    &:hover {
      transform: scale(1.05);
    }
  }
}

.card-info {
  flex: 1;
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.zone-title {
  font-size: 16px;
  font-weight: 500;
  color: #2c3e50;
  margin-bottom: 8px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
}

.zone-mileage {
  margin-top: 12px;
  font-size: 14px;
  color: #666;
}

.zone-guide {
  margin-top: 12px;
  font-size: 14px;
  color: #666;
}

// 卡片描述
.card-description {
  font-size: 14px;
  line-height: 1.6;
  color: #666;
  margin-bottom: 16px;
  height: 63px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.card-actions {
  border-top: 1px solid #f0f0f0;
  padding-top: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

// 分页样式
.pagination-container {
  margin-top: 30px;
  text-align: center;
}

a {
  color: #1E8EF2;
  font-size: 14px;
}

.ml10 {
  margin-left: 10px;
}
</style>